<template>
  <vcl-facebook v-if="loading"></vcl-facebook>
  <div v-else>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_remote_addr" v-b-tooltip.hover>Attacker <b-badge @click="info_xff = true" v-if="model.xff" variant='success' style='cursor: pointer;'>XFF (?)</b-badge> </label><br></b>
                <label for="ph_remote_addr" v-b-tooltip.hover v-if="this.model">
                  <CountryFlag v-if="model.country" class="explain" :country="model.country" size='normal' style="border: 1px solid gray; padding: 0px 10px; box-shadow: 2px 2px 2px 2px gray;"/>
                  <span v-if="model.xff">{{model.xff}} ({{model.remote_addr}})</span>
                  <span v-else>{{model.remote_addr}}</span>
                </label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_target" v-b-tooltip.hover>Victim</label><br></b>
                <label for="ph_target" v-b-tooltip.hover v-if="this.model">{{model.target}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_response" v-b-tooltip.hover>Response</label><br></b>
                <b-badge v-if="model.is_block && this.model.block_cnt > 0" variant="danger">BlockMode</b-badge>
                <b-badge v-else variant="warning">DetectMode</b-badge>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="!parser_request">
              <b-form-group>
                <b><label for="ph_request" v-b-tooltip.hover>Request</label><br></b>
                <!-- <label for="ph_request" v-b-tooltip.hover>{{model.request}}</label> -->
                <pre> {{split_uri(model.request || '')}}</pre>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_protocol" v-b-tooltip.hover>Protocol</label><br></b>
                <label for="ph_protocol" v-b-tooltip.hover>{{model.protocol}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_host" v-b-tooltip.hover>Host</label><br></b>
                <label for="ph_host" v-b-tooltip.hover>{{model.host}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b>
                  <label for="ph_uri" v-b-tooltip.hover>
                    URI <small>:</small>
                    <b-button v-if="model.uri.length > 100" size="sm" @click="view_split_uri = !view_split_uri" variant="info">
                      {{view_split_uri ? 'split' : 'origin'}} view
                    </b-button>
                  </label>
                </b>
                <br>
                <pre v-if="view_split_uri" for="ph_uri" v-b-tooltip.hover>{{model.uri}}</pre>
                <pre v-else>{{split_uri(model.uri || '')}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="parser_request">
            <b-col md="12">
              <b-form-group>
                <b>
                  <label for="ph_request" v-b-tooltip.hover>
                    Request<small>:</small>
                  </label>
                  <b-button size="sm" @click="view_split_request = !view_split_request" variant="info">
                    {{view_split_uri ? 'split' : 'origin'}} view
                  </b-button>
                </b>
                <pre v-if="view_split_request" for="ph_uri" v-b-tooltip.hover>{{model.request}}</pre>
                <pre v-else>{{split_uri(model.request || '')}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_seed" v-b-tooltip.hover>Request Headers</label><br></b>
                <pre for="ph_seed" v-b-tooltip.hover>{{model.headers}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <center>
            Matched Information
          </center>
          <hr>
          <table v-if="is_error" class="table table-sm table-dark">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Message</th>
                <th scope="col">Rule ID</th>
                <!-- <th scope="col">Maturity</th>
                <th scope="col">Accuracy</th> -->
                <th scope="col">Response</th>
                <th scope="col">Risk</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in ([model.message] || [])" :key="index">
                <th scope="row">{{index + 1}}</th>
                <th scope="row">{{row.message}}</th>
                <th scope="row">{{row.details.ruleId}}</th>
                <!-- <th scope="row">{{row.details.maturity}}</th>
                <th scope="row">{{row.details.accuracy}}</th> -->
                <th>
                  <b-badge v-if="row.is_detect == 0" variant="danger">차단</b-badge>
                  <b-badge v-else variant="warning">탐지</b-badge>
                </th>

                <th scope="row" v-if="row.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 1"><b-badge variant="danger">Alert</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 2"><b-badge variant="danger">Critical</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 3"><b-badge variant="warning">Error</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 4"><b-badge variant="warning">Warning</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 5"><b-badge variant="info">Notice</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 6"><b-badge variant="info">Info</b-badge></th>
                <th scope="row" v-else><b-badge variant="dark">Not recognized</b-badge></th>
                <th scope="row" v-else>Not Defined</th>
              </tr>
            </tbody>
          </table>
          <table v-else class="table table-sm table-dark">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Message</th>
                <th scope="col">Rule ID</th>
                <!-- <th scope="col">Maturity</th>
                <th scope="col">Accuracy</th> -->
                <th scope="col">Response</th>
                <th scope="col">Risk</th>
                <th v-if="!only_view" scope="col">Manage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                <th scope="row">{{index + 1}}</th>
                <th scope="row">
                  {{ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['ENG'] : row.message }}
                </th>
                <th scope="row">{{row.details.ruleId}}</th>
                <!-- <th scope="row">{{row.details.maturity}}</th>
                <th scope="row">{{row.details.accuracy}}</th> -->
                <th>
                  <b-badge v-if="row.is_info" variant="dark">-</b-badge>
                  <b-badge v-else-if="row.is_detect == 0" variant="danger">Block</b-badge>
                  <b-badge v-else variant="warning">Detect</b-badge>
                </th>

                <th scope="row" v-if="row.details.severity == 0"><b-badge variant="danger">Emergency</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 1"><b-badge variant="danger">Alert</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 2"><b-badge variant="danger">Critical</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 3"><b-badge variant="warning">Error</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 4"><b-badge variant="warning">Warning</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 5"><b-badge variant="info">Notice</b-badge></th>
                <th scope="row" v-else-if="row.details.severity == 6"><b-badge variant="info">Info</b-badge></th>
                <th scope="row" v-else><b-badge variant="dark">Not recognized</b-badge></th>
                <th v-if="!only_view">
                  <b-btn @click=" exception_info = { msg : row.message, detail : row.details, agent_id : model.agent_id }; exception_info_modal_add = true; exception_info_modal_remove = false" size="sm" variant="warning">Exception</b-btn>
                  <b-btn @click=" exception_info = { msg : row.message, detail : row.details, agent_id : model.agent_id }; exception_info_modal_remove = true; exception_info_modal_add = false" size="sm" variant="success">Exception Remove</b-btn>
                </th>
              </tr>
            </tbody>
          </table>
          <hr>

          <b-button v-if="!id" size="sm" class="float-right" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
    <!-- result modal -->
    <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-success" v-model="info_xff" hide-footer @ok="info_xff = false">
      XFF: Displayed when proxy is set to X-Forwarded-For
    </b-modal>
    <b-modal size="l" title="설정 예외 처리"  class="modal-success" v-model="exception_info_modal_add" @ok="add_white">
      This Policy({{exception_policy_msg}}) applies to "{{exception_policy_name}}" by exception ?
    </b-modal>
    <b-modal size="m" title="설정 예외 처리"  class="modal-success" v-model="exception_info_modal_remove" @ok="remove_white">
      applied exception policy({{exception_policy_msg}}) remove on "{{exception_policy_name}} policy"?
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
